export default __webpack_public_path__ + "static/media/stancare01.d101cc40.png";